module.exports = __webpack_public_path__ + "static/img/img10.834699b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/img10.png
// module id = Omny
// module chunks = 5